
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazin/[slug]/[mid]",
      function () {
        return require("private-next-pages/magazin/[slug]/[mid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazin/[slug]/[mid]"])
      });
    }
  